export default "https://cdn-static.gokick.com/assets/ea2c661fec3366c14365f7d1c68d2a3d0c715dc9/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";